import * as angular from "angular";
import { Feature } from "../../models/feature.model";
import { PermissionCheck } from "../../shared/permission";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";

let UpdateUserUrlTextDialogComponent = {
    selector: "vcUpdateUserUrlTextDialog",
    templateUrl:
        "/angular/components/organisation-settings/update-user-url-text-dialog.component.html",
    bindings: {},
    controller: class UpdateUserUrlTextDialogController {
        private saving: boolean = false;
        private feature: Feature;

        private dialog: DialogUtils;
        private toast: ToastUtils;
        private permissionProvider: PermissionCheck;

        constructor(
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            PermissionCheck: PermissionCheck
        ) {
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
            this.permissionProvider = PermissionCheck;

            this.permissionProvider
                .getFeature("USER_URL")
                .then((feature: Feature) => {
                    this.feature = feature;
                    this.feature.attributes.extra = this.feature.attributes
                        .extra
                        ? this.feature.attributes.extra
                        : {};
                    this.feature.attributes.extra["userURLText"] = this.feature
                        .attributes.extra["userURLText"]
                        ? this.feature.attributes.extra["userURLText"]
                        : "";
                });
        }

        cancel(): void {
            this.dialog.cancel();
        }

        saveUserURLText(): void {
            this.saving = true;
            this.feature.update().then(
                (feature) => {
                    this.feature.setData(feature);
                    this.permissionProvider.updateFeaturePermission(
                        feature.attributes
                    );
                    this.dialog.hide();
                    this.toast.success("User URL text updated");
                },
                () => {
                    this.dialog.hide();
                    this.toast.error();
                }
            );
        }
    },
};

angular
    .module("organisationSettings")
    .component(
        UpdateUserUrlTextDialogComponent.selector,
        UpdateUserUrlTextDialogComponent
    );
